module.exports = __webpack_public_path__ + "img/bottom_lightning.4ba4e864.png";